

































































import { Vue, Component } from "vue-property-decorator";

import { namespace } from "vuex-class";

const Integration = namespace("integration");

@Component({
  metaInfo() {
    return {
      title: "Orba One | API Keys",
    };
  },
})
export default class Keys extends Vue {
  @Integration.Action("fetchCredentials") fetchCredentials!: () => Promise<{}>;
  @Integration.Getter("getPublicKey") publicKey;
  @Integration.Getter("getSecretKey") secretKey;

  beforeMount() {
    this.fetchCredentials().catch((err) => console.log(err));
  }
}
